module.exports = __webpack_public_path__ + "static/media/03fa-prime.d959a841.png";